<template>
    <div class="flex flex-col cursor-pointer text-left group relative card-dimensions border hover:border-black p-4">
        <span class="absolute right-4 top-4 opacity-0 focus-within:opacity-100 group-hover:opacity-100">
            <button
                @click.prevent.stop="toggleProductOptionsDialog($event, {card, availability, pricing})"
                class="h-10 w-10 rounded-full bg-gray-100 p-0.5 duration-150 hover:bg-gray-125 active:bg-gray-150"
            >
                <BaseSvg
                    name="icon-addition-sign"
                    aria-hidden="true"
                />
                <span class="sr-only">Add to…</span>
            </button>
        </span>
        <div class="h-48 flex items-center justify-center">
            <img
                :src="productCardImage(card)"
                :alt="'Product image for ' + card?.display_sku"
                class="max-h-32"
                v-if="productCardImage(card)"
            />
            <BaseSvg
                v-else
                name="icon-products-cube"
                class="w-24 fill-gray relative h-full z-10"
                aria-hidden="true"
            />
        </div>
        <h6 class="capitalize type-secondary text-sm">
            {{ card?.filter_manufacturer ?? "" }}
        </h6>
        <h5 class="text-lg type-primary font-bold group-hover:underline underline-offset-4">
            <!-- Bubble up clicks to contextual handler declared on component instance -->
            <button type="button">{{ card?.display_sku }}</button>
        </h5>
        <p class="text-sm type-primary overflow-hidden line-clamp-3">
            {{ card?.display_short_description ?? "" }}
        </p>
        <div class="grow"></div>
        <div class="flex gap-4">
            <div class="type-tertiary">
                <span class="font-medium">{{ showMeTheMoney(card.list_price) }}</span> <span class="text-2xs uppercase">{{ $t("List") }}</span>
            </div>
            <div v-if="pricing" class="type-primary">
                <span class="font-medium">{{ showMeTheMoney(pricing.price) }}</span> <span class="text-2xs uppercase type-tertiary">{{ $t("Cost") }}</span>
            </div>
        </div>
        <AvailabilityList
            v-if="availability"
            :hide-button="true"
            v-bind="props"
            :hide-quantity="false"
        />
    </div>
</template>

<script setup>
import {AvailabilityList, BaseSvg} from "@/Components";
import {useHelpers, useProductOptionsDialog, useAssetTransforms} from "@/Composables";

const {productCardImage} = useAssetTransforms();
const { toggleProductOptionsDialog } = useProductOptionsDialog();
const { showMeTheMoney } = useHelpers();
const props = defineProps(["card", "pricing", "availability"]);
</script>

<style scoped>
.card-dimensions {
    height: 420px;
    width: 300px;
}
</style>
